import { render } from "./ScoreboardPhonemicConsonant.vue?vue&type=template&id=ee9cb3fa&scoped=true"
import script from "./ScoreboardPhonemicConsonant.vue?vue&type=script&lang=js"
export * from "./ScoreboardPhonemicConsonant.vue?vue&type=script&lang=js"

import "@/css/components/scoreboard-phonemic-consonant.css?vue&type=style&index=0&id=ee9cb3fa&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9cb3fa"]])

export default __exports__